import { ca } from '@cian/analytics';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';
import { getBlockTypeByInfrastructureType } from './getBlockTypeByInfrastructureType';
import { TTAInfrastructureType } from '../../../types/map';

export function trackTransportAccessibilityPinClick(infrastructureType: TTAInfrastructureType) {
  const objectType = toAnalyticsObjectType(infrastructureType);
  const blockType = getBlockTypeByInfrastructureType(infrastructureType, []);

  ca('eventSite', {
    action: 'click_sopr',
    category: 'Index_transport',
    label: 'pin',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
        block_type: blockType,
      },
    },
  });
}
